import * as CONSTANTS from 'constants';
import moment from 'moment-timezone';

export const phoneConverter = (num) => {
    if (!num) return null;
    let phone = num;
    phone = phone.replace(/(\d{3})(\d{3})(\d+)/, '($1) $2-$3');
    return phone;
};

export const hexToRGBA = (hex, a = 1) => {
    if (!hex) return 'rgba(0,0,0,0.5)';
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export const validNumber = (e) => {
    if (!e) return false;
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
        return true;
    } else {
        return false;
    }
};

export const validBirthDate = (data) => {
    if (!data) return '';
    let result = `${data.slice(0, 2)}/${data.slice(2, 4)}/${data.slice(4)}`;
    return result;
};

export const getDateFormat = (authUser, site) => {
    if (authUser && authUser.preferredDateFormat == 'default') {
        if (site && site.sitePreferredDateFormat == 'DD-MM-YYYY') {
            return 'DD-MM-YYYY';
        } else {
            return 'MM/DD/YYYY';
        }
    } else if (authUser && authUser.preferredDateFormat == 'DD-MM-YYYY') {
            return 'DD-MM-YYYY';
    } else {
            return 'MM/DD/YYYY';
    }
};

export const dateFormatter = (date, authUser, site) => {
    if (!date) return '';
    if(authUser && authUser.preferredDateFormat == 'default'){
        if(site && site.sitePreferredDateFormat == 'DD-MM-YYYY'){
            return moment(date).format('DD-MM-YYYY');
        } else {
            return moment(date).format('MM/DD/YYYY');
        }
    } else if (authUser && authUser.preferredDateFormat == 'DD-MM-YYYY'){
            return moment(date).format('DD-MM-YYYY');
    } else {
            return moment(date).format('MM/DD/YYYY');
    }
};

export const dateTimeFormatter = (dateTime, authUser, site, userTimezone) => {
    if (!dateTime || (!site || !site.timeZone) || !userTimezone) return '';
    if(authUser && authUser.preferredDateFormat == 'default'){
        if(site && site.sitePreferredDateFormat == 'DD-MM-YYYY'){
            if(authUser && authUser.useSiteTime && site){
                return moment(dateTime).tz(site.timeZone).format('DD-MM-YYYY LT');
            } else {
                return moment(dateTime).tz(userTimezone).format('DD-MM-YYYY LT');
            }
        } else {
            if(authUser && authUser.useSiteTime && site){
                return moment(dateTime).tz(site.timeZone).format('MM/DD/YYYY LT');
            } else {
                return moment(dateTime).tz(userTimezone).format('MM/DD/YYYY LT');
            }
        }
    } else if (authUser && authUser.preferredDateFormat == 'DD-MM-YYYY'){
        if(authUser && authUser.useSiteTime && site){
            return moment(dateTime).tz(site.timeZone).format('DD-MM-YYYY LT');
        } else {
            return moment(dateTime).tz(userTimezone).format('DD-MM-YYYY LT');
        }
    } else {
        if(authUser && authUser.useSiteTime && site){
            return moment(dateTime).tz(site.timeZone).format('MM/DD/YYYY LT');
        } else {
            return moment(dateTime).tz(userTimezone).format('MM/DD/YYYY LT');
        }
    }
};

export const dateTimeFormatterReturnTimeOnly = (dateTime, authUser, site, userTimezone) => {
    if (!dateTime || (!site || !site.timeZone) || !userTimezone) return '';
    
        if(authUser && authUser.useSiteTime && site){
            return moment(dateTime).tz(site.timeZone).format('LT');
        } else {
            return moment(dateTime).tz(userTimezone).format('LT');
        }
   
};

export const dateTimeFormatterReurnDateOnly = (dateTime, authUser, site, userTimezone) => {
    if (!dateTime || (!site || !site.timeZone) || !userTimezone) return '';
    if(authUser && authUser.preferredDateFormat == 'default'){
        if(site && site.sitePreferredDateFormat == 'DD-MM-YYYY'){
            if(authUser && authUser.useSiteTime && site){
                return moment(dateTime).tz(site.timeZone).format('DD-MM-YYYY');
            } else {
                return moment(dateTime).tz(userTimezone).format('DD-MM-YYYY');
            }
        } else {
            if(authUser && authUser.useSiteTime && site){
                return moment(dateTime).tz(site.timeZone).format('MM/DD/YYYY');
            } else {
                return moment(dateTime).tz(userTimezone).format('MM/DD/YYYY');
            }
        }
    } else if (authUser && authUser.preferredDateFormat == 'DD-MM-YYYY'){
        if(authUser && authUser.useSiteTime && site){
            return moment(dateTime).tz(site.timeZone).format('DD-MM-YYYY');
        } else {
            return moment(dateTime).tz(userTimezone).format('DD-MM-YYYY');
        }
    } else {
        if(authUser && authUser.useSiteTime && site){
            return moment(dateTime).tz(site.timeZone).format('MM/DD/YYYY');
        } else {
            return moment(dateTime).tz(userTimezone).format('MM/DD/YYYY');
        }
    }
};

export const getActivityTime = (
    timestamp,
    authUser,
    site,
    userTimezone
) => {
    const timezone = authUser.useSiteTime ? site.timeZone : userTimezone;
    return moment.tz(timestamp, timezone).format('MM/DD/YYYY - h:mma');
}

export const getTimeSince = (
    timestamp,
    authUser,
    site,
    userTimezone,
    returnMinutesOnly = false,
    toTimestamp
  ) => {
    let sitetimezone='America/New_York';
    if (site && site.timeZone !== undefined && site.timeZone !== null) {
        sitetimezone = site.timeZone
    }
    if(userTimezone === undefined || userTimezone === null){
        userTimezone = 'America/New_York';
    }
    const timezone = authUser.useSiteTime ? sitetimezone : userTimezone;
    let localTime;
    if (timezone) {
        localTime = moment.utc(timestamp).tz(timezone);
    } else {
        localTime = moment.utc(timestamp);
    }

    if (!localTime.isValid()) return returnMinutesOnly ? 0 : "Invalid time";
  
    let now = toTimestamp
    ? moment(toTimestamp).utc().tz(timezone)
    : timezone
    ? moment.utc().tz(timezone)
    : moment.utc();

    const duration = moment.duration(now.diff(localTime));
  
    if (returnMinutesOnly) {
        return duration.asMinutes();
    }
  
    const years = Math.floor(duration.asYears());
    const months = duration.months();
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
  
    const parts = [];
    if (years > 0) parts.push(`${years} yr${years > 1 ? "s" : ""}`);
    if (months > 0) parts.push(`${months} mon${months > 1 ? "s" : ""}`);
    if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hr${hours > 1 ? "s" : ""}`);
    if (minutes > 0 || parts.length === 0)
      parts.push(`${minutes} min${minutes > 1 ? "s" : ""}`);
  
    return parts.join(" ");
};

export const returnTimeFromTimestamp = (
    timestamp,
    authUser,
    site,
    userTimezone
) => {
    const timezone = authUser.useSiteTime ? site.timeZone : userTimezone;
    const localTime = moment.utc(timestamp).tz(timezone);
  
    if (!localTime.isValid()) return "Invalid time";
  
    const now = moment().tz(timezone);
  
    if (localTime.isSame(now, 'day')) {
      return localTime.format("h:mm A"); // Today
    } else if (localTime.isSame(now.clone().subtract(1, 'day'), 'day')) {
      return `Yesterday ${localTime.format("h:mm A")}`;
    }
  
    // Fallback if needed, e.g. for older dates
    return localTime.format("MMM D, h:mm A");
};

export const returnDateFromTimestamp = (
    timestamp,
    authUser,
    site,
    userTimezone
  ) => {
    const timezone = authUser.useSiteTime ? site.timeZone : userTimezone;
    const localTime = moment.utc(timestamp).tz(timezone);
  
    if (!localTime.isValid()) return "Invalid date";
  
    return localTime.format("MMM. D"); // e.g., "Sep. 15"
};

export const updateCheckbox = (newData, array, e, parse) => {
    let name = parse ? JSON.parse(e.target.name) : e.target.name;
    if (e.target.checked) {
        newData[array].push(name);
        return newData;
    } else {
        newData[array] = newData[array].filter((item) => item != name);
        return newData;
    }
};

export const updateCheckbox2 = (newData, e, parse) => {
    let name = parse ? JSON.parse(e.target.name) : e.target.name;
    if (e.target.checked) {
        newData.push(name);
        return newData;
    } else {
        newData = newData.filter((item) => item != name);
        return newData;
    }
};

export const updateCheckbox3 = (newData = [], name, checked) => {
    if (checked) {
        newData.push(name);
        return newData;
    } else {
        newData = newData.filter((item) => item != name);
        return newData;
    }
};

export const findIndex = (list, key, property) => {
    if (list == null || !key || !property) return;
    let active = list.findIndex((item) => item[key] === property);
    return active;
};

export const checkForScrollbars = (element, dir) => {
    if (!element) return false;
    dir = dir === 'vertical' ? 'scrollTop' : 'scrollLeft';
    let res = !!element[dir];
    if (!res) {
        element[dir] = 1;
        res = !!element[dir];
        element[dir] = 0;
    }
    return res;
};

export const cleanUpArray = (arr = [], comp = 'id') => {
    const unique = arr
        .map((e) => e[comp])
        .map((e, i, final) => final.indexOf(e) === i && i)
        .filter((e) => arr[e])
        .map((e) => arr[e]);
    return unique;
};

export const removeDuplicates = (arr = [], filter = []) => {
    const listOfTags = arr,
        keys = filter,
        output = listOfTags.filter(
            (
                (s) => (o) =>
                    ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join('|'))
            )(new Set())
        );
    return output;
};

export const findArrayEquals = (arr = [], key = '', valueToCheck) => {
    let found = false;
    arr.some((value) => {
        if (value[key] === valueToCheck) {
            found = true;
            return true;
        }
    });
    return found;
};

export const filterList = (list = [], typeSet, searchValue = '') => {
    if (list == null || typeSet == null || !searchValue) return null;
    const lowerSearchValue = searchValue.toLowerCase();
    return list.filter((obj) => {
        return Array.from(typeSet).some((key) => {
            const value = obj[key];
            if (value != null) {
                const strValue = JSON.stringify(value).toLowerCase();
                return strValue.includes(lowerSearchValue);
            }
        });
    });
};

export const filterListStart = (list = [], type, searchValue = '') => {
    let newList = list.filter((obj) => obj.name.toLowerCase().startsWith(searchValue.toLowerCase()));
    return newList;
};

export const filterArray = (list = [], type = '', array = []) => {
    let newList = list.filter((obj) => array.includes(obj[type]));
    newList = newList.length > 0 ? newList : [];
    return newList;
};

export const sortList = (order = true, list = [], property = '') => {
    // Intl object not supported by all browsers. This could be useless because we use Intl in many npm modules
    if (typeof Intl == 'undefined') return list;
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    if (!collator) return list;
    list.sort((a, b) => collator.compare(order ? b[property] : a[property], order ? a[property] : b[property]));
    return list;
};

export const checkPMS = (site) => {
    if (!site) return false;
    return !CONSTANTS.PMS_BYPASS.includes(site.pms);
};

export const moveListToFront = (compareList = [], list = [], property = '') => {
    let temp = list.filter((item) => compareList.includes(item[property]));
    list = list.filter((item) => !compareList.includes(item[property]));
    let newList = temp.concat(list);
    return newList;
};

export const moveListToFront2 = (list = [], property = '', checker) => {
    let temp = list.filter((item) => item[property] === checker);
    list = list.filter((item) => item[property] != checker);
    let newList = temp.concat(list);
    return newList;
};

export const lightenDarkenColor = (color, percent) => {
    if (!color || !percent) return null;
    var num = parseInt(color.replace('#', ''), 16),
        amt = Math.round(2.55 * percent),
        R = (num >> 16) + amt,
        B = ((num >> 8) & 0x00ff) + amt,
        G = (num & 0x0000ff) + amt;

    return (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
        (G < 255 ? (G < 1 ? 0 : G) : 255)
    )
        .toString(16)
        .slice(1);
};

export const setWithExpiry = (key, value, ttl) => {
    if (!key) return null;
    const item = {
        value: value,
        expiry: new Date().getTime() + ttl
    };
    localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key) => {
    if (!key) return null;
    const itemString = window.localStorage.getItem(key);
    if (!itemString) return null;

    const item = JSON.parse(itemString);
    const isExpired = new Date().getTime() > item.expiry;

    if (isExpired) {
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
};

export const waitForElement = (selector) => {
    if (!selector) return null;
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            return;
        }

        const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

export const removeAllToolTips = () => {
    const tooltips = document.querySelectorAll('.my-tooltip');
    tooltips.forEach((node) => node.remove());
};

export const generateTextID = (length = 15) => {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export const checkInView = (container, element, partial = true) => {
    if (!container || !element) return false;
    //Get container properties
    let cTop = container.scrollTop;
    let cBottom = cTop + container.clientHeight;

    //Get element properties
    let eTop = element.offsetTop;
    let eBottom = eTop + element.clientHeight;

    //Check if in view
    let isTotal = eTop >= cTop && eBottom <= cBottom;
    let isPartial = partial && ((eTop < cTop && eBottom > cTop) || (eBottom > cBottom && eTop < cBottom));

    //Return outcome
    return isTotal || isPartial;
};

export const isOverflown = (element) => {
    if (!element) return false;
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};

export const validateEmail = (email) => {
    if (!email) return '';
    var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
    var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
    var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
    var sQuotedPair = '\\x5c[\\x00-\\x7f]';
    var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
    var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
    var sDomain_ref = sAtom;
    var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
    var sWord = '(' + sAtom + '|' + sQuotedString + ')';
    var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
    var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
    var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
    var sValidEmail = '^' + sAddrSpec + '$'; // as whole string
    var reValidEmail = new RegExp(sValidEmail);
    return reValidEmail.test(email);
};

export const limitStringLength = (str, len) => {
    if (!str || !len) return '';
    return len < str.length ? `${str.substr(0, len)}...` : str;
};

export const getCursorPos = (input) => {
    if (!input) return -1;
    if ("selectionStart" in input && document.activeElement == input) {
        return {
            start: input.selectionStart,
            end: input.selectionEnd
        };
    }
    else if (input.createTextRange) {
        var sel = document.selection.createRange();
        if (sel.parentElement() === input) {
            var rng = input.createTextRange();
            rng.moveToBookmark(sel.getBookmark());
            for (var len = 0;
                     rng.compareEndPoints("EndToStart", rng) > 0;
                     rng.moveEnd("character", -1)) {
                len++;
            }
            rng.setEndPoint("StartToStart", input.createTextRange());
            for (var pos = { start: 0, end: len };
                     rng.compareEndPoints("EndToStart", rng) > 0;
                     rng.moveEnd("character", -1)) {
                pos.start++;
                pos.end++;
            }
            return pos;
        }
    }
    return -1;
}

export const setCursorPos = (ctrl, pos) => {
    if (!ctrl || !pos) return;
    if (ctrl.setSelectionRange) {
        ctrl.focus();
        ctrl.setSelectionRange(pos, pos);

    // IE8 and below
    } else if (ctrl.createTextRange) {
        var range = ctrl.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
    }
}

export const isTouchDevice = () => {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

export const getCountryCode = (flag) => {
    if (flag == '🇦🇩') return 'AD';
    if (flag == '🇦🇪') return 'AE';
    if (flag == '🇦🇫') return 'AF';
    if (flag == '🇦🇬') return 'AG';
    if (flag == '🇦🇮') return 'AI';
    if (flag == '🇦🇱') return 'AL';
    if (flag == '🇦🇲') return 'AM';
    if (flag == '🇦🇴') return 'AO';
    if (flag == '🇦🇶') return 'AQ';
    if (flag == '🇦🇷') return 'AR';
    if (flag == '🇦🇸') return 'AS';
    if (flag == '🇦🇹') return 'AT';
    if (flag == '🇦🇺') return 'AU';
    if (flag == '🇦🇼') return 'AW';
    if (flag == '🇦🇽') return 'AX';
    if (flag == '🇦🇿') return 'AZ';
    if (flag == '🇧🇦') return 'BA';
    if (flag == '🇧🇧') return 'BB';
    if (flag == '🇧🇩') return 'BD';
    if (flag == '🇧🇪') return 'BE';
    if (flag == '🇧🇫') return 'BF';
    if (flag == '🇧🇬') return 'BG';
    if (flag == '🇧🇭') return 'BH';
    if (flag == '🇧🇮') return 'BI';
    if (flag == '🇧🇯') return 'BJ';
    if (flag == '🇧🇱') return 'BL';
    if (flag == '🇧🇲') return 'BM';
    if (flag == '🇧🇳') return 'BN';
    if (flag == '🇧🇴') return 'BO';
    if (flag == '🇧🇶') return 'BQ';
    if (flag == '🇧🇷') return 'BR';
    if (flag == '🇧🇸') return 'BS';
    if (flag == '🇧🇹') return 'BT';
    if (flag == '🇧🇻') return 'BV';
    if (flag == '🇧🇼') return 'BW';
    if (flag == '🇧🇾') return 'BY';
    if (flag == '🇧🇿') return 'BZ';
    if (flag == '🇨🇦') return 'CA';
    if (flag == '🇨🇨') return 'CC';
    if (flag == '🇨🇩') return 'CD';
    if (flag == '🇨🇫') return 'CF';
    if (flag == '🇨🇬') return 'CG';
    if (flag == '🇨🇭') return 'CH';
    if (flag == '🇨🇮') return 'CI';
    if (flag == '🇨🇰') return 'CK';
    if (flag == '🇨🇱') return 'CL';
    if (flag == '🇨🇲') return 'CM';
    if (flag == '🇨🇳') return 'CN';
    if (flag == '🇨🇴') return 'CO';
    if (flag == '🇨🇷') return 'CR';
    if (flag == '🇨🇺') return 'CU';
    if (flag == '🇨🇻') return 'CV';
    if (flag == '🇨🇼') return 'CW';
    if (flag == '🇨🇽') return 'CX';
    if (flag == '🇨🇾') return 'CY';
    if (flag == '🇨🇿') return 'CZ';
    if (flag == '🇩🇪') return 'DE';
    if (flag == '🇩🇯') return 'DJ';
    if (flag == '🇩🇰') return 'DK';
    if (flag == '🇩🇲') return 'DM';
    if (flag == '🇩🇴') return 'DO';
    if (flag == '🇩🇿') return 'DZ';
    if (flag == '🇪🇨') return 'EC';
    if (flag == '🇪🇪') return 'EE';
    if (flag == '🇪🇬') return 'EG';
    if (flag == '🇪🇭') return 'EH';
    if (flag == '🇪🇷') return 'ER';
    if (flag == '🇪🇸') return 'ES';
    if (flag == '🇪🇹') return 'ET';
    if (flag == '🇫🇮') return 'FI';
    if (flag == '🇫🇯') return 'FJ';
    if (flag == '🇫🇰') return 'FK';
    if (flag == '🇫🇲') return 'FM';
    if (flag == '🇫🇴') return 'FO';
    if (flag == '🇫🇷') return 'FR';
    if (flag == '🇬🇦') return 'GA';
    if (flag == '🇬🇧') return 'GB';
    if (flag == '🇬🇩') return 'GD';
    if (flag == '🇬🇪') return 'GE';
    if (flag == '🇬🇫') return 'GF';
    if (flag == '🇬🇬') return 'GG';
    if (flag == '🇬🇭') return 'GH';
    if (flag == '🇬🇮') return 'GI';
    if (flag == '🇬🇱') return 'GL';
    if (flag == '🇬🇲') return 'GM';
    if (flag == '🇬🇳') return 'GN';
    if (flag == '🇬🇵') return 'GP';
    if (flag == '🇬🇶') return 'GQ';
    if (flag == '🇬🇷') return 'GR';
    if (flag == '🇬🇸') return 'GS';
    if (flag == '🇬🇹') return 'GT';
    if (flag == '🇬🇺') return 'GU';
    if (flag == '🇬🇼') return 'GW';
    if (flag == '🇬🇾') return 'GY';
    if (flag == '🇭🇰') return 'HK';
    if (flag == '🇭🇲') return 'HM';
    if (flag == '🇭🇳') return 'HN';
    if (flag == '🇭🇷') return 'HR';
    if (flag == '🇭🇹') return 'HT';
    if (flag == '🇭🇺') return 'HU';
    if (flag == '🇮🇩') return 'ID';
    if (flag == '🇮🇪') return 'IE';
    if (flag == '🇮🇱') return 'IL';
    if (flag == '🇮🇲') return 'IM';
    if (flag == '🇮🇳') return 'IN';
    if (flag == '🇮🇴') return 'IO';
    if (flag == '🇮🇶') return 'IQ';
    if (flag == '🇮🇷') return 'IR';
    if (flag == '🇮🇸') return 'IS';
    if (flag == '🇮🇹') return 'IT';
    if (flag == '🇯🇪') return 'JE';
    if (flag == '🇯🇲') return 'JM';
    if (flag == '🇯🇴') return 'JO';
    if (flag == '🇯🇵') return 'JP';
    if (flag == '🇰🇪') return 'KE';
    if (flag == '🇰🇬') return 'KG';
    if (flag == '🇰🇭') return 'KH';
    if (flag == '🇰🇮') return 'KI';
    if (flag == '🇰🇲') return 'KM';
    if (flag == '🇰🇳') return 'KN';
    if (flag == '🇰🇵') return 'KP';
    if (flag == '🇰🇷') return 'KR';
    if (flag == '🇰🇼') return 'KW';
    if (flag == '🇰🇾') return 'KY';
    if (flag == '🇰🇿') return 'KZ';
    if (flag == '🇱🇦') return 'LA';
    if (flag == '🇱🇧') return 'LB';
    if (flag == '🇱🇨') return 'LC';
    if (flag == '🇱🇮') return 'LI';
    if (flag == '🇱🇰') return 'LK';
    if (flag == '🇱🇷') return 'LR';
    if (flag == '🇱🇸') return 'LS';
    if (flag == '🇱🇹') return 'LT';
    if (flag == '🇱🇺') return 'LU';
    if (flag == '🇱🇻') return 'LV';
    if (flag == '🇱🇾') return 'LY';
    if (flag == '🇲🇦') return 'MA';
    if (flag == '🇲🇨') return 'MC';
    if (flag == '🇲🇩') return 'MD';
    if (flag == '🇲🇪') return 'ME';
    if (flag == '🇲🇫') return 'MF';
    if (flag == '🇲🇬') return 'MG';
    if (flag == '🇲🇭') return 'MH';
    if (flag == '🇲🇰') return 'MK';
    if (flag == '🇲🇱') return 'ML';
    if (flag == '🇲🇲') return 'MM';
    if (flag == '🇲🇳') return 'MN';
    if (flag == '🇲🇴') return 'MO';
    if (flag == '🇲🇵') return 'MP';
    if (flag == '🇲🇶') return 'MQ';
    if (flag == '🇲🇷') return 'MR';
    if (flag == '🇲🇸') return 'MS';
    if (flag == '🇲🇹') return 'MT';
    if (flag == '🇲🇺') return 'MU';
    if (flag == '🇲🇻') return 'MV';
    if (flag == '🇲🇼') return 'MW';
    if (flag == '🇲🇽') return 'MX';
    if (flag == '🇲🇾') return 'MY';
    if (flag == '🇲🇿') return 'MZ';
    if (flag == '🇳🇦') return 'NA';
    if (flag == '🇳🇨') return 'NC';
    if (flag == '🇳🇪') return 'NE';
    if (flag == '🇳🇫') return 'NF';
    if (flag == '🇳🇬') return 'NG';
    if (flag == '🇳🇮') return 'NI';
    if (flag == '🇳🇱') return 'NL';
    if (flag == '🇳🇴') return 'NO';
    if (flag == '🇳🇵') return 'NP';
    if (flag == '🇳🇷') return 'NR';
    if (flag == '🇳🇺') return 'NU';
    if (flag == '🇳🇿') return 'NZ';
    if (flag == '🇴🇲') return 'OM';
    if (flag == '🇵🇦') return 'PA';
    if (flag == '🇵🇪') return 'PE';
    if (flag == '🇵🇫') return 'PF';
    if (flag == '🇵🇬') return 'PG';
    if (flag == '🇵🇭') return 'PH';
    if (flag == '🇵🇰') return 'PK';
    if (flag == '🇵🇱') return 'PL';
    if (flag == '🇵🇲') return 'PM';
    if (flag == '🇵🇳') return 'PN';
    if (flag == '🇵🇷') return 'PR';
    if (flag == '🇵🇸') return 'PS';
    if (flag == '🇵🇹') return 'PT';
    if (flag == '🇵🇼') return 'PW';
    if (flag == '🇵🇾') return 'PY';
    if (flag == '🇶🇦') return 'QA';
    if (flag == '🇷🇪') return 'RE';
    if (flag == '🇷🇴') return 'RO';
    if (flag == '🇷🇸') return 'RS';
    if (flag == '🇷🇺') return 'RU';
    if (flag == '🇷🇼') return 'RW';
    if (flag == '🇸🇦') return 'SA';
    if (flag == '🇸🇧') return 'SB';
    if (flag == '🇸🇨') return 'SC';
    if (flag == '🇸🇩') return 'SD';
    if (flag == '🇸🇪') return 'SE';
    if (flag == '🇸🇬') return 'SG';
    if (flag == '🇸🇭') return 'SH';
    if (flag == '🇸🇮') return 'SI';
    if (flag == '🇸🇯') return 'SJ';
    if (flag == '🇸🇰') return 'SK';
    if (flag == '🇸🇱') return 'SL';
    if (flag == '🇸🇲') return 'SM';
    if (flag == '🇸🇳') return 'SN';
    if (flag == '🇸🇴') return 'SO';
    if (flag == '🇸🇷') return 'SR';
    if (flag == '🇸🇸') return 'SS';
    if (flag == '🇸🇹') return 'ST';
    if (flag == '🇸🇻') return 'SV';
    if (flag == '🇸🇽') return 'SX';
    if (flag == '🇸🇾') return 'SY';
    if (flag == '🇸🇿') return 'SZ';
    if (flag == '🇹🇨') return 'TC';
    if (flag == '🇹🇩') return 'TD';
    if (flag == '🇹🇫') return 'TF';
    if (flag == '🇹🇬') return 'TG';
    if (flag == '🇹🇭') return 'TH';
    if (flag == '🇹🇯') return 'TJ';
    if (flag == '🇹🇰') return 'TK';
    if (flag == '🇹🇱') return 'TL';
    if (flag == '🇹🇲') return 'TM';
    if (flag == '🇹🇳') return 'TN';
    if (flag == '🇹🇴') return 'TO';
    if (flag == '🇹🇷') return 'TR';
    if (flag == '🇹🇹') return 'TT';
    if (flag == '🇹🇻') return 'TV';
    if (flag == '🇹🇼') return 'TW';
    if (flag == '🇹🇿') return 'TZ';
    if (flag == '🇺🇦') return 'UA';
    if (flag == '🇺🇬') return 'UG';
    if (flag == '🇺🇲') return 'UM';
    if (flag == '🇺🇸') return 'US';
    if (flag == '🇺🇾') return 'UY';
    if (flag == '🇺🇿') return 'UZ';
    if (flag == '🇻🇦') return 'VA';
    if (flag == '🇻🇨') return 'VC';
    if (flag == '🇻🇪') return 'VE';
    if (flag == '🇻🇬') return 'VG';
    if (flag == '🇻🇮') return 'VI';
    if (flag == '🇻🇳') return 'VN';
    if (flag == '🇻🇺') return 'VU';
    if (flag == '🇼🇫') return 'WF';
    if (flag == '🇼🇸') return 'WS';
    if (flag == '🇽🇰') return 'XK';
    if (flag == '🇾🇪') return 'YE';
    if (flag == '🇾🇹') return 'YT';
    if (flag == '🇿🇦') return 'ZA';
    if (flag == '🇿🇲') return 'ZM';
    return 'US';
};

// Check for European countries as well as Saudi Arabia

export const checkEurope = (site) => {
    let countries = ['UK',
    'GB',
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'IS',
    'LI',
    'NO',
    'CH',
    'AL',
    'ME',
    'MK',
    'RS',
    'TR',
    'AD',
    'BY',
    'BA',
    'MD',
    'MC',
    'RU',
    'SM',
    'UA',
    'VA',
    'SA',
    'EU']
    if(site && site.country && countries.includes(site.country)){
        return true
    } else { return false }
}

export const getHardwareType = (char) => {
    if (char === '1A') {
        return 'Nokē ONE';
    } else if (char === '2A') {
        return 'Nokē Contact';
    } else if (char === '1W' || char === '2E' || char === '3E') {
        return 'Nokē Volt';
    } else if (char === '4E') {
        return 'Nokē Ion';
    } else if (char === '5E') {
        return 'Nokē Ion-2.0';
    } else if (char === '3K') {
        return 'Nokē Pad';
    } else if (char === '4K') {
        return 'Nokē Screen';
    } else if (char === '1R') {
        return 'Nokē Repeater';
    } else {
        return ''
    }
};

const ActionType = {
    ENTERED: { id: 1, label: 'entered', solo: true, suspicious: false },
    ENTERED_TAILGATED: { id: 2, label: 'entered-tailgated', solo: false, suspicious: false },
    EXITED_GATE: { id: 3, label: 'exited-gate', solo: false, suspicious: false },
    EXITED_CRON: { id: 4, label: 'exited-cron', solo: false, suspicious: false },
    UNLOCKED_UNIT: { id: 6, label: 'unlocked-unit', solo: true, suspicious: false },
    LOCKED_UNIT: { id: 7, label: 'locked-unit', solo: true, suspicious: false },
    OUT_OF_ZONE_ATTEMPT: { id: 8, label: 'out-of-zone-attempt', solo: true, suspicious: true },
    AFTER_HOURS_ENTRY_ATTEMPT: { id: 9, label: 'after-hours-attempt', solo: true, suspicious: true },
    AFTER_HOURS_EXIT: { id: 10, label: 'after-hours-exit', solo: false, suspicious: false },
    AFTER_HOURS_EXIT_ATTEMPT: { id: 11, label: 'after-hours-exit-attempt', solo: false, suspicious: true },
    ENTRY_REMOTE_OPENED: { id: 14, label: 'entry-remote-opened', solo: true, suspicious: false },
    UNIT_REMOTE_OPENED: { id: 15, label: 'unit-remote-opened', solo: true, suspicious: false },
    NON_EMERGENCY_UNLOCK: { id: 16, label: 'non-emergency-unlock', solo: true, suspicious: false },
    EMERGENCY_UNLOCK: { id: 17, label: 'emergency-unlock', solo: true, suspicious: false },
    LOCK_ALARM: { id: 18, label: 'lock-alarm', solo: true, suspicious: true, },
    LOCK_FAILED_UNLOCK: { id: 19, label: 'lock-failed-unlock', solo: true, suspicious: false },
    LOCK_FAILED_UNLOCK_BLACKLISTED: { id: 20, label: 'lock-failed-unlock-blacklisted', solo: true, suspicious: false },
    LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE: { id: 21, label: 'lock-failed-unlock-invalid-accesscode', solo: true, suspicious: false },
    LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE_GATELOCKED: { id: 22, label: 'lock-failed-unlock-invalid-accesscode-gatelocked', solo: true, suspicious: false },
    LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE_OUT_OF_ZONE: { id: 23, label: 'lock-failed-unlock-invalid-accesscode-out-of-zone', solo: true, suspicious: true },
    LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE_OVERLOCKED: { id: 24, label: 'lock-failed-unlock-invalid-acccesscode-overlocked', solo: true, suspicious: false },
    LOCK_FAILED_UNLOCK_OUT_OF_SCHEDULE: { id: 25, label: 'lock-failed-unlock-out-of-schedule', solo: true, suspicious: true },
    LOCK_FAILED_UNLOCK_OVERLOCKED: { id: 26, label: 'lock-failed-unlock-overlocked', solo: true, suspicious: false },
    LOCK_FORCED_ENTRY: { id: 27, label: 'lock-forced-entry', solo: true, suspicious: true },
    LOCK_MOTION_START: { id: 28, label: 'lock-motion-start', solo: true, suspicious: true },
    LOCK_MOTION_STOP: { id: 29, label: 'lock-motion-stop', solo: true, suspicious: true },
    UNIT_SET_STATE: { id: 30, label: 'unit-set-state', solo: true, suspicious: true },
    UNIT_ASSIGN: { id: 31, label: 'unit-assign', solo: true, suspicious: true },
    MOVE_IN: { id: 32, label: 'move-in', solo: true, suspicious: false },
    MOVE_OUT: { id: 33, label: 'move-out', solo: true, suspicious: false },
    MECHANICAL_OVERRIDE: { id: 34, label: 'mechnical-override', solo: true, suspicious: true}
    // …add more as needed
};

const actionRules = [
    {
        type: ActionType.ENTERED,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            const isExit = e.lock && e.lock.isExit;
            return hw &&
                !['exitgate','unit','repeater','alarm','demo'].includes(hw) &&
                !isExit &&
                [
                    'unlock.accessed_offline_access_code',
                    'unlock.accessed_offline_fob',
                    'unlock.accessed_offline_phone',
                    'unlock.accessed_online_phone_bt',
                ].includes(e.subtype)
        }
    },
    {
        type: ActionType.EXITED_GATE,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            const isExit = e.lock && e.lock.isExit;
            return hw &&
                (hw === 'exitgate' || isExit) &&
                [
                    'unlock.accessed_offline_access_code',
                    'unlock.accessed_offline_fob',
                    'unlock.accessed_offline_phone',
                    'unlock.accessed_online_phone_bt',
                ].includes(e.subtype)
        }
    },
    {
        type: ActionType.UNLOCKED_UNIT,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            return hw &&
            hw === 'unit' &&
            [
                'unlock.accessed_offline_access_code',
                'unlock.accessed_offline_fob',
                'unlock.accessed_offline_phone',
                'unlock.accessed_online_phone_bt',
            ].includes(e.subtype)
        }
    },
    {
        type: ActionType.LOCKED_UNIT,
        matches: (e) =>
            e.lock &&
            e.lock.hwType === 'unit' &&
            e.subtype === 'lock.locked'
    },
    {
        type: ActionType.OUT_OF_ZONE_ATTEMPT,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            return hw &&
                !['unit','repeater','alarm','demo'].includes(hw) &&
                e.subtype === 'lock.failed_unlock.invalid_accesscode.out_of_zone';
        }
    },
    {
        type: ActionType.AFTER_HOURS_ENTRY_ATTEMPT,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            return hw &&
                !['exitgate','unit','repeater','alarm','demo'].includes(hw) &&
                e.subtype === 'lock.failed_unlock.out_of_schedule'
        }
    },
    {
        type: ActionType.AFTER_HOURS_EXIT,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            return hw &&
                hw === 'exitgate' &&
                e.subtype === 'lock.unlock'
        }
    },
    {
        type: ActionType.AFTER_HOURS_EXIT_ATTEMPT,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            return hw &&
                hw === 'exitgate' &&
                e.subtype === 'lock.failed_unlock.out_of_schedule'
        }
    },
    {
        type: ActionType.ENTRY_REMOTE_OPENED,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            return hw &&
                !['exitgate','unit','repeater','alarm','demo'].includes(hw) &&
                e.subtype === 'unlock.accessed_online_phone_mesh';
        }
    },
    {
        type: ActionType.UNIT_REMOTE_OPENED,
        matches: (e) => {
            const hw = e.lock && e.lock.hwType;
            return hw &&
                hw === 'unit' &&
                e.subtype === 'unlock.accessed_online_phone_mesh';
        }
    },
    {
        type: ActionType.NON_EMERGENCY_UNLOCK,
        matches: (e) => {
            return e.subtype === 'lock.override.use';
        }
    },
    {
        type: ActionType.EMERGENCY_UNLOCK,
        matches: (e) => {
            return e.subtype === 'lock.emergency';
        }
    },
    {
        type: ActionType.LOCK_ALARM,
        matches: (e) => {
            return e.subtype === 'lock.alarm';
        }
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK,
        matches: (e) => {
            return e.subtype === 'lock.failed_unlock';
        }
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK_BLACKLISTED,
        matches: (e) => e.subtype === 'lock.failed_unlock.blacklisted'
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE,
        matches: (e) => e.subtype === 'lock.failed_unlock.invalid_accesscode'
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE_GATELOCKED,
        matches: (e) => e.subtype === 'lock.failed_unlock.invalid_accesscode.Gatelocked'
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE_OUT_OF_ZONE,
        matches: (e) => e.subtype === 'lock.failed_unlock.invalid_accesscode.out_of_zone'
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK_INVALID_ACCESSCODE_OVERLOCKED,
        matches: (e) => e.subtype === 'lock.failed_unlock.invalid_accesscode.overlocked'
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK_OUT_OF_SCHEDULE,
        matches: (e) => e.subtype === 'lock.failed_unlock.out_of_schedule'
    },
    {
        type: ActionType.LOCK_FAILED_UNLOCK_OVERLOCKED,
        matches: (e) => e.subtype === 'lock.failed_unlock.overlocked'
    },
    {
        type: ActionType.LOCK_FORCED_ENTRY,
        matches: (e) => e.subtype === 'lock.forced_entry'
    },
    {
        type: ActionType.LOCK_MOTION_START,
        matches: (e) => e.subtype === 'lock.motionstart'
    },
    {
        type: ActionType.LOCK_MOTION_STOP,
        matches: (e) => e.subtype === 'lock.motionstop'
    },
    {
        type: ActionType.UNIT_SET_STATE,
        matches: (e) => e.subtype === 'site.unit.setstate'
    },
    {
        type: ActionType.UNIT_ASSIGN,
        matches: (e) => e.subtype === 'unit.assign' && e.unit.accessType !== 'service' && e.unit.accessType !== 'employee'
    },
    {
        type: ActionType.MOVE_IN,
        matches: (e) => e.subtype === 'user.move.in'
    },
    {
        type: ActionType.MOVE_OUT,
        matches: (e) => e.subtype === 'user.move.out'
    },
    {
        type: ActionType.MECHANICAL_OVERRIDE,
        matches: (e) => e.subtype === 'unlock.unlocked_mechanical_override'
    }

    // …more rules
];

function formatState(state) {
    switch (state) {
        case 'available':
            return "Available";
        case 'inuse':
            return "Occupied";
        case 'overlock':
            return "Overlock";
        case 'repo':
            return "Pending Auction";
        case 'auction-smartentry':
            return "Auction";
        case 'transfer-smartentry':
            return "Transfer";
        case 'prelet':
            return "prelet";
        case 'checkout':
            return "Checkout";
        default:
            return state;
    }  
} 

const STANDALONE_ACTIONS = [
    // 'after-hours-attempt',
    'entry-remote-opened',
    'unit-remote-opened',
    'non-emergency-unlock',
    'emergency-unlock',
    'lock-alarm',
    // 'out-of-zone-attempt',
    'lock-failed-unlock',
    'lock-failed-unlock-blacklisted',
    'lock-failed-unlock-invalid-accesscode',
    'lock-failed-unlock-invalid-accesscode-Gatelocked',
    'lock-failed-unlock-invalid-accesscode-out_of_zone',
    'lock-failed-unlock-invalid-accesscode-overlocked',
    'lock-failed-unlock-out-of-schedule',
    'lock-failed-unlock-overlocked',
    'lock-forced-entry',
    'lock-motion-start',
    'lock-motion-stop',
    'unit-set-state',
    'unit-assign',
    'mechnical-override',
    'move-in',
    'move-out'
];

const NOTABLE_DEVICE_LABELS = [
    'out-of-zone-attempt',
    'lock-failed-unlock',
    'lock-failed-unlock-blacklisted',
    'lock-failed-unlock-invalid-accesscode',
    'lock-failed-unlock-invalid-accesscode-Gatelocked',
    'lock-failed-unlock-invalid-accesscode-out_of_zone',
    'lock-failed-unlock-invalid-accesscode-overlocked',
    'lock-failed-unlock-out-of-schedule',
    'lock-failed-unlock-overlocked',
    'lock-forced-entry',
    'lock-motion-start',
    'lock-motion-stop',
    'unit-set-state',
    'unit-assign',
    'mechnical-override'
]

const NOTABLE_USER_LABELS = [
    'non-emergency-unlock',
    'unit-assign'
]

// Classify one event into an ActionType or null if none match
function classifyEvent(event) {
    for (let rule of actionRules) {
      if (rule.matches(event)) {
        return rule.type;
      }
    }
    return null;
}

function enrichSession(session, e, action) {
    const { by, for: forUser, lock, unit } = e.event;
  
    if (!session.roleName && Array.isArray(by?.byRoles) && by.byRoles[0]?.role_name) {
      session.roleName = by.byRoles[0].role_name;
    }
  
    session.unitName ||= unit?.name || null;
    session.entryName ||= lock?.name || unit?.name || null;
    session.reason ||= e.event.reason || null;
  
    if (action.label === 'exited-gate') {
      session.end = e.createdAt;
    }
  
    if (NOTABLE_DEVICE_LABELS.includes(action.label)) {
      session.notableDevice = lock?.name || unit?.name || null;
      session.notableTime = e.createdAt;
      if (action.label === 'lock-failed-unlock' && !session.reason) {
        session.reason = e.event.lockFailedUnlockType
            ? e.event.lockFailedUnlockType
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())
            : "";
      }
    }
  
    if (NOTABLE_USER_LABELS.includes(action.label)) {
      session.notableUser = forUser?.firstName && forUser?.lastName
        ? `${forUser.firstName} ${forUser.lastName}`
        : 'Unknown user';
    }

    if (action.label === 'unit-set-state') {
        session.notableState = formatState(unit.rentalState);
    }
  
    session.events.push({ event: e, action });
}

// still need to account for tailgate!!! how can we figure if the first action is not an enter event and the site has entries?
function buildNewSession(e, action) {
    const { by, for: forUser, lock, unit } = e.event;
  
    const userName = by?.firstName && by?.lastName
      ? `${by.firstName} ${by.lastName}`
      : 'Unknown user';

    const session = {
      user: by,
      start: e.createdAt,
      end: action.label === 'exited-gate' ? e.createdAt : null,
      events: action.label === 'entered' || STANDALONE_ACTIONS.includes(action.label) || action.label === 'out-of-zone-attempt' || action.label === 'after-hours-attempt' ? [{ event: e, action }] : [{ action: ActionType.ENTERED }, { event: e, action }],
      userName,
      entryName: lock?.name || unit?.name || null,
      unitName: unit?.name || null,
      roleName: Array.isArray(by?.byRoles) && by.byRoles[0]?.role_name || null,
      accessCode: e.accessCode || null,
      reason: e.event.reason || null
    };
  
    if (NOTABLE_DEVICE_LABELS.includes(action.label)) {
      session.notableDevice = lock?.name || unit?.name || null;
      session.notableTime = e.createdAt;
      if (action.label === 'lock-failed-unlock' && !session.reason) {
        session.reason = e.event.lockFailedUnlockType
            ? e.event.lockFailedUnlockType
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())
            : "";
      }
    }
  
    if (NOTABLE_USER_LABELS.includes(action.label)) {
      session.notableUser = forUser?.firstName && forUser?.lastName
        ? `${forUser.firstName} ${forUser.lastName}`
        : 'Unknown user';
    }

    if (action.label === 'unit-set-state') {
        session.notableState = formatState(unit.rentalState);
    }
  
    return session;
}

function buildSessions(events, removedUsers) {
    const sessionsByUser = {};
    const suspicious = [];

    const removalMap = {};
    for (const removal of removedUsers) {
        const userId = removal.forUserID;
        if (!removalMap[userId]) {
            removalMap[userId] = [];
        }
        removalMap[userId].push(removal.createdAt);
    }

    for (const e of events) {
        // PV-103 if remote unlocks are from tenant then it was actually done via gateway fallback and should still be marked as by phone and not remote
        if (e.event.by?.byRoles && e.event.by.byRoles[0].role_tier === "0" && e.event.subtype === "unlock.accessed_online_phone_mesh") {
            e.event.subtype = "unlock.accessed_online_phone_bt";
        }
        const action = classifyEvent(e.event);
        
        if (!action) continue;

        const userId = e.event.by?.userId;

        if (action.suspicious && !(e.event.unit && (e.event.unit.accessType === 'service' || e.event.unit.accessType === 'employee'))) {
            suspicious.push({
                action: action,
                event: e
            });
        }
        
        // Initialize session array for user
        if (!sessionsByUser[userId]) {
            sessionsByUser[userId] = [];
        }
        
        // these can safely stand alone since they aren't part of any combinations
        if (STANDALONE_ACTIONS.includes(action.label)) {
            const standaloneSession = buildNewSession(e, action);
            standaloneSession.end ||= e.createdAt;
            sessionsByUser[userId].push(standaloneSession);
            continue;
        }

        // these don't always come with a user attached so we'll have to find that and attach to that session
        if (action.label === 'locked-unit') {
            const unitName = e.event.unit.name;

            for (const userSessions of Object.values(sessionsByUser)) {
              const match = userSessions.find(sess => sess.unitName === unitName && !sess.end);
              if (match) {
                enrichSession(match, e, action);
                break;
              }
            }
            continue;
        }

        const userSessions = sessionsByUser[userId];
        const lastSession = userSessions[userSessions.length - 1];
        
        let shouldStartNewSession = false;

        if (!lastSession) {
            shouldStartNewSession = true;
        } else if (lastSession.end) {
            shouldStartNewSession = true;
        } else {
            // Handle cron-based removal timing
            const removalQueue = removalMap[userId];
            if (removalQueue?.length && lastSession && !lastSession.end) {
                const nextRemovalTime = removalQueue[0];
                const eventTime = new Date(e.createdAt);
                const removalTime = new Date(nextRemovalTime);

                if (eventTime > removalTime) {
                    // End current session using cron
                    lastSession.end = nextRemovalTime;
                    lastSession.events.push({ action: ActionType.EXITED_CRON });
                    removalQueue.shift(); // Remove used removal timestamp
                    shouldStartNewSession = true;
                }
            }
        }
            
        if (shouldStartNewSession) {
            const newSession = buildNewSession(e, action);
            userSessions.push(newSession);
        } else {
            enrichSession(lastSession, e, action); // merge event into existing session
        }
    }

    // add leftover removals
    for (const [userId, timestamps] of Object.entries(removalMap)) {
        const userSessions = sessionsByUser[userId];
        if (!userSessions?.length) continue;
    
        let removalQueue = timestamps;
    
        for (const session of userSessions) {
            if (!session.end && removalQueue.length) {
                const removalTime = removalQueue.shift();
                session.end = removalTime;
                session.events.push({ action: ActionType.EXITED_CRON });
            }
        }
    }

    // Flatten all sessions into a single list
    const sessions = Object.values(sessionsByUser).flat().sort((a, b) => new Date(b.start) - new Date(a.start));
    const sortedSuspicious = Array.isArray(suspicious)
    ? [...suspicious].sort((a, b) => new Date(b.event.createdAt) - new Date(a.event.createdAt))
    : [];

    // Sort by start time
    return {
        whatsNew: Object.values(sessions),
        suspicious: sortedSuspicious
    }
}

export const buildActivityFeed = (events, removedUsers = []) => {
    // 1. Sessionize
    const sessions = buildSessions(events, removedUsers);
    return sessions;
}
